import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const listItemTabClassName = classnames(
  'rank-brain-2-sidebar-guide-section-tab',
);

const listItemTabStyle = {
  marginBottom: 11,
};

const SidebarGuideTab = (props) => {
  const title = props.sectionItem.title;
  return (
    <li
      className={listItemTabClassName}
      style={listItemTabStyle}
      key={title}
    >
      <span>{title}</span>
    </li>
  );
};

SidebarGuideTab.defaultProps = {
  sectionItem: {},
};

SidebarGuideTab.propTypes = {
  sectionItem: PropTypes.shape({
    title: PropTypes.string,
  }),
};

export default SidebarGuideTab;



// WEBPACK FOOTER //
// ./src-react/RankBrain2SidebarNavbar/SidebarGuideInfoSection/SidebarGuideTab.jsx